import{getDefaultExportFromCjs as e}from"./_commonjsHelpers.mjs";import{__require as r}from"../us_enrichment/Response.mjs";var m=e(r());export{m as default};
